import React from 'react'
import Link from 'gatsby-link'
import Calendar from '../images/calendar.svg'
import Tag from '../images/tag.svg'
import View from '../images/view.svg'
import Img from 'gatsby-image'
import Quotes from '../components/Quotes/Quotes.jsx'
import Announcement from '../components/Announcement/Announcement.jsx'
const IndexPage = ({ data }) => {
  const { edges: posts } = data.allMarkdownRemark
  return (
    <div className="main-wrapper animated fadeIn">
      <h1>
        thoughts
        <span className="title-end">_</span>
      </h1>
      <div className="subtitle">
        My everyday thoughts are presented here. Case studies and video
        presentations.
      </div>
      <Quotes />
      <Announcement />
      <section className="blog-listing">
        {posts.map(({ node: post }) => {
          const { frontmatter } = post
          return (
            <article className="post-item" key={frontmatter.title}>
              <div className="post-thumbnail">
                <Link to={frontmatter.path}>
                  <Img
                    sizes={frontmatter.featuredImage.childImageSharp.sizes}
                    className="thumbnail"
                  />
                  <div className="view-icon">
                    <img src={View} alt="Phanor Coll" />
                  </div>
                </Link>
              </div>
              <div className="post-details">
                <header className="post-detail">
                  <div className="title">
                    <Link to={frontmatter.path}>{frontmatter.title}</Link>
                  </div>
                </header>
                <div className="post-excerpt">{frontmatter.excerpt}</div>
                <div className="post-date">
                  <div className="date-icon">
                    <img src={Calendar} alt="Phanor Coll" />
                  </div>
                  <div className="date">{frontmatter.date}</div>
                </div>
                <div className="post-tags">
                  <div className="post-icon">
                    <img src={Tag} alt="Phanor Coll" />
                  </div>
                  <div className="tag-list">
                    <ul>
                      {frontmatter.tags.map(tag => {
                        return (
                          <li key={tag}>
                            <Link to={`/tags/${tag}`} className="a-animation">
                              {tag}
                            </Link>
                          </li>
                        )
                      })}
                    </ul>
                  </div>
                </div>
              </div>
            </article>
          )
        })}
      </section>
    </div>
  )
}

export const query = graphql`
  query IndexQuery {
    allMarkdownRemark(
      sort: { fields: [frontmatter___date], order: DESC }
      filter: {
        frontmatter: { category: { eq: "blog" }, published: { eq: "true" } }
      }
    ) {
      totalCount
      edges {
        node {
          id
          frontmatter {
            title
            date(formatString: "MMMM DD, YYYY")
            path
            tags
            excerpt
            featuredImage {
              childImageSharp {
                sizes(maxWidth: 491) {
                  ...GatsbyImageSharpSizes
                  originalName
                }
              }
            }
          }
        }
      }
    }
  }
`

export default IndexPage



// WEBPACK FOOTER //
// ./src/pages/index.js